module.exports = __webpack_public_path__ + "static/media/SejinH.6bfafe1e.jpeg";